import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { memo } from "react";
import { PERSONAL_INFORMATION } from "@jti/fe-common";
import { MethodType } from "./MethodType/MethodType";
export const MethodSelection = memo(({ methods, selectedMethod, selectMethod }) => {
    const isSingleMethod = methods.length === 1;
    return (_jsx(_Fragment, { children: methods
            .filter(({ code }) => code !== PERSONAL_INFORMATION)
            .map((method) => (_jsx(MethodType, { isSingleMethod: isSingleMethod, method: method, selectedMethod: selectedMethod, selectMethod: selectMethod }, method.code))) }));
});
//# sourceMappingURL=MethodSelection.js.map